import { ReportColumn } from '../shared/types';
import { formatMoney } from '@/utils/currency';

export interface ItemAnalysisRow {
  item_code: string;
  item_name: string;
  quantity_purchased: number;
  purchase_value: number;
  average_cost: number;
  last_purchase_cost: number;
  highest_cost: number;
  lowest_cost: number;
  cost_difference: number;
  cost_difference_pct: number;
  supplier_count: number;
}

export const itemAnalysisColumns: ReportColumn<ItemAnalysisRow>[] = [
  { id: 'item_code', header: 'Item Code', accessorKey: 'item_code' },
  { id: 'item_name', header: 'Item Name', accessorKey: 'item_name' },
  { id: 'quantity_purchased', header: 'Quantity Purchased', accessorKey: 'quantity_purchased', align: 'right' },
  {
    id: 'purchase_value',
    header: 'Purchase Value',
    align: 'right',
    cell: (r) => `${formatMoney(r.purchase_value)}`,
    exportValue: (r) => r.purchase_value,
  },
  {
    id: 'average_cost',
    header: 'Average Cost',
    align: 'right',
    cell: (r) => `${formatMoney(r.average_cost)}`,
    exportValue: (r) => r.average_cost,
  },
  {
    id: 'last_purchase_cost',
    header: 'Last Purchase Cost',
    align: 'right',
    cell: (r) => `${formatMoney(r.last_purchase_cost)}`,
    exportValue: (r) => r.last_purchase_cost,
  },
  {
    id: 'highest_cost',
    header: 'Highest Cost',
    align: 'right',
    cell: (r) => `${formatMoney(r.highest_cost)}`,
    exportValue: (r) => r.highest_cost,
  },
  {
    id: 'lowest_cost',
    header: 'Lowest Cost',
    align: 'right',
    cell: (r) => `${formatMoney(r.lowest_cost)}`,
    exportValue: (r) => r.lowest_cost,
  },
  {
    id: 'cost_difference',
    header: 'Cost Difference',
    align: 'right',
    cell: (r) => `${formatMoney(r.cost_difference)}`,
    exportValue: (r) => r.cost_difference,
  },
  {
    id: 'cost_difference_pct',
    header: 'Cost Difference %',
    align: 'right',
    cell: (r) => `${Number(r.cost_difference_pct || 0).toFixed(1)}%`,
    exportValue: (r) => r.cost_difference_pct,
  },
  { id: 'supplier_count', header: 'Supplier Count', accessorKey: 'supplier_count', align: 'right' },
];
